export const GLOBAL_SETTINGS_COLLECTION = "globalSettings";
export const GLOBAL_LEGAL_DOC_ID = "legal";

export type LegalLocale = "es" | "en";

export interface LegalSection {
  es: string;
  en: string;
  version: string; // e.g. "2025-01-15"
  updatedAt?: Date | null;
  updatedBy?: string | null;
}

export interface GlobalLegalDocument {
  terms: LegalSection;
  privacyPolicy: LegalSection;
  updatedAt?: Date | null;
}

export interface UserLegalAcceptance {
  acceptTerms: boolean;
  acceptPrivacyPolicy: boolean;
  legalLocale?: LegalLocale;
  termsVersion?: string;
  privacyPolicyVersion?: string;
  acceptedAt?: Date;
}
